import { Alert } from '@pmi/dsm-react';
import { useParams } from 'react-router';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { AlertWarningSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import { useGetAccountDataQuery } from '../../shared/navigation/apiSlice';
import {
  useGetConsentDetailsQuery,
  useUpdateConsentMutation,
} from './apiSlice';
import { toastWithAnalytics } from '../../shared/analytics';
// import AuthService from '../../shared/services/AuthService';
import { impersonatedBySelector } from '../../shared/store/shared/impersonationBySlice';
import ConsentOptional from './ConsentOptional';
import ConsentMandatory from './ConsentMandatory';
import AuthService from '../../shared/services/AuthService';

export default function Settings() {
  const { accountId } = useParams<{ accountId: string }>();
  const { hasImpersonatedBy } = useSelector(impersonatedBySelector);
  const { data: accountData, isLoading } = useGetAccountDataQuery(accountId);
  const [updateConsent, updateConsentStatus] = useUpdateConsentMutation();
  const authService = new AuthService();

  const { data: consentData, isLoading: isConsentLoading } =
    useGetConsentDetailsQuery();

  if (isLoading || isConsentLoading || updateConsentStatus.isLoading) {
    return (
      <div className="p-5">
        <Spinner className="d-block m-auto" />
      </div>
    );
  }

  const handleUpdateConsent = async (consentFlag: boolean) => {
    try {
      await updateConsent({
        body: {
          flag: consentFlag,
        },
      }).unwrap();

      if (consentFlag) {
        toastWithAnalytics(
          'Your consent to sharing data was updated successfully.',
          'success',
        );
      } else {
        toastWithAnalytics(
          'Your consent to sharing data was removed successfully.',
          'success',
        );
      }
      if (!accountData.isAnonymizable && !consentFlag) {
        setTimeout(() => authService.logout(), 500);
      }
    } catch (error) {
      toastWithAnalytics(
        'Your consent to sharing data was not removed.',
        'danger',
      );
    }
  };

  return (
    <>
      {hasImpersonatedBy && (
        <div className="pb-4">
          <Alert
            variant="warning"
            alertText="Warning: only proceed or make changes if you have the express consent of the user for whom you are impersonating!"
            icon={AlertWarningSolidIcon}
          />
        </div>
      )}
      {(isLoading || isConsentLoading) && <p>Loading...</p>}
      {accountData.isAnonymizable && !isLoading && !isConsentLoading && (
        <ConsentOptional
          accountData={accountData}
          consentData={consentData}
          handleUpdateConsent={handleUpdateConsent}
        />
      )}
      {!accountData.isAnonymizable && !isLoading && !isConsentLoading && (
        <ConsentMandatory
          accountData={accountData}
          consentData={consentData}
          handleUpdateConsent={handleUpdateConsent}
        />
      )}
    </>
  );
}
